import { EVENTS, subscribe } from 'ia-util-pubsub'

export class IaProductCard extends HTMLElement {
  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
    this.sectionId = this.dataset.sectionId
    this.productId = this.dataset.productId
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber()
  }

  handleVariantChange({ detail }) {
    const { html, variant } = detail
    if (!html || !variant || detail.sectionId !== this.sectionId || detail.productId !== this.productId) return
    // Find the new gallery HTML from the loaded variant section
    const newCard = html.querySelector('ia-product-card')
    if (!newCard) return
    // Replace the current card with the new one
    this.outerHTML = newCard.outerHTML

  }

}

customElements.define('ia-product-card', IaProductCard)